
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.687 11.777L11.091 8.6a.669.669 0 000-1.153L5.687 4.268a.669.669 0 00-1.007.576V11.2c0 .517.561.838 1.007.576zm6.082-2.026c1.318-.775 1.318-2.682 0-3.457L6.365 3.115c-1.337-.786-3.022.178-3.022 1.729V11.2c0 1.551 1.685 2.515 3.022 1.729l5.404-3.179z","fill":"currentColor"}})])
          )
        }
      }
    